import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TexteService } from './core/services/texte.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent {

  constructor(public texteService: TexteService) { }

}
